import {Model} from "@vuex-orm/core";

export default class WebsiteProductCountry extends Model {

    static entity = 'websiteProductCountry';

    static primaryKey = ['website_product_id', 'country_id'];

    static fields () {
        return {
            website_product_id: this.number(null).nullable(),
            country_id: this.number(null).nullable(),
        }
    }
}
